module.exports = __webpack_public_path__ + "980248afbe36f00a9554c4cb8606d569.png";